import { render, staticRenderFns } from "./LearningUnitEvaluationScoreCard.vue?vue&type=template&id=f980afb2&scoped=true&"
import script from "./LearningUnitEvaluationScoreCard.vue?vue&type=script&lang=js&"
export * from "./LearningUnitEvaluationScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./LearningUnitEvaluationScoreCard.vue?vue&type=style&index=0&id=f980afb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f980afb2",
  null
  
)

export default component.exports